/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';

/**
 * 
 * @export
 * @interface MilestoneCheckpoint
 */
export interface MilestoneCheckpoint {
    /**
     * Progress threshold to unlock this checkpoint (e.g., 5, 10, 25)
     * @type {number}
     * @memberof MilestoneCheckpoint
     */
    threshold: number;
    /**
     * Checkpoint name (e.g., "First Blood", "Double Digits")
     * @type {string}
     * @memberof MilestoneCheckpoint
     */
    name: string;
    /**
     * Optional checkpoint description
     * @type {string}
     * @memberof MilestoneCheckpoint
     */
    description?: string;
    /**
     * What this checkpoint's numbers count — "Likes", "Finds". Absent renders the bare count.
     * @type {string}
     * @memberof MilestoneCheckpoint
     */
    progressUnit?: string;
    /**
     * Reward IDs granted when checkpoint is claimed
     * @type {Array<string>}
     * @memberof MilestoneCheckpoint
     */
    rewardConfigIds: Array<string>;
    /**
     * Per-reward auto-claim settings. Key is rewardConfigId, value is true for auto-reward, false for manual claim.
     * @type {{ [key: string]: boolean; }}
     * @memberof MilestoneCheckpoint
     */
    rewardAutoSettings?: { [key: string]: boolean; };
    /**
     * Full reward config objects (populated from rewardConfigIds)
     * @type {Array<RewardConfigResponse>}
     * @memberof MilestoneCheckpoint
     */
    rewardConfigs?: Array<RewardConfigResponse>;
    /**
     * Catalog-item grants (reward-catalog Option B) — additive alongside rewardConfigIds during the migration.
     * @type {Array<RewardGrant>}
     * @memberof MilestoneCheckpoint
     */
    rewardGrants?: Array<RewardGrant>;
}

/**
 * Check if a given object implements the MilestoneCheckpoint interface.
 */
export function instanceOfMilestoneCheckpoint(value: object): value is MilestoneCheckpoint {
    if (!('threshold' in value) || value['threshold'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rewardConfigIds' in value) || value['rewardConfigIds'] === undefined) return false;
    return true;
}

export function MilestoneCheckpointFromJSON(json: any): MilestoneCheckpoint {
    return MilestoneCheckpointFromJSONTyped(json, false);
}

export function MilestoneCheckpointFromJSONTyped(json: any, ignoreDiscriminator: boolean): MilestoneCheckpoint {
    if (json == null) {
        return json;
    }
    return {
        
        'threshold': json['threshold'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'progressUnit': json['progressUnit'] == null ? undefined : json['progressUnit'],
        'rewardConfigIds': json['rewardConfigIds'],
        'rewardAutoSettings': json['rewardAutoSettings'] == null ? undefined : json['rewardAutoSettings'],
        'rewardConfigs': json['rewardConfigs'] == null ? undefined : ((json['rewardConfigs'] as Array<any>).map(RewardConfigResponseFromJSON)),
        'rewardGrants': json['rewardGrants'] == null ? undefined : ((json['rewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
    };
}

export function MilestoneCheckpointToJSON(json: any): MilestoneCheckpoint {
    return MilestoneCheckpointToJSONTyped(json, false);
}

export function MilestoneCheckpointToJSONTyped(value?: MilestoneCheckpoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'threshold': value['threshold'],
        'name': value['name'],
        'description': value['description'],
        'progressUnit': value['progressUnit'],
        'rewardConfigIds': value['rewardConfigIds'],
        'rewardAutoSettings': value['rewardAutoSettings'],
        'rewardConfigs': value['rewardConfigs'] == null ? undefined : ((value['rewardConfigs'] as Array<any>).map(RewardConfigResponseToJSON)),
        'rewardGrants': value['rewardGrants'] == null ? undefined : ((value['rewardGrants'] as Array<any>).map(RewardGrantToJSON)),
    };
}

